module.exports = __webpack_public_path__ + "img/lock.e4e380fd.svg";